import { withStyles } from '@material-ui/core';

import LargeRadioGroup from './LargeRadioGroup';
import { styles } from './LargeRadioGroup.styles';

const LargeRadioGroupContainer = withStyles(styles)(LargeRadioGroup);

export default LargeRadioGroupContainer;
